/**
 * Fixture data for Revenue Flow / Pipeline landing previews.
 * Minimal Deal and Lead shapes compatible with InPlayBlock, WonBlock, LostBlock.
 */

import type { Deal } from "@/hooks/useDeals";
import type { Lead } from "@/hooks/useLeads";

const ws = "demo-workspace";

export const mockLeads: Lead[] = [
  {
    id: "lead-1",
    workspace_id: ws,
    name: "Acme Corp",
    company: "Acme Inc",
    phone: "+39 333 1234567",
    temperature: "hot",
    pipeline_stage: "qualified",
    next_follow_up_at: new Date(Date.now() - 86400000).toISOString(),
    last_interaction_at: new Date(Date.now() - 172800000).toISOString(),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    archived: false,
  } as Lead,
  {
    id: "lead-2",
    workspace_id: ws,
    name: "Beta Ltd",
    company: "Beta",
    phone: "+39 333 7654321",
    temperature: "warm",
    pipeline_stage: "proposal_sent",
    next_follow_up_at: new Date(Date.now() + 86400000).toISOString(),
    last_interaction_at: new Date(Date.now() - 86400000).toISOString(),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    archived: false,
  } as Lead,
  {
    id: "lead-3",
    workspace_id: ws,
    name: "Gamma Co",
    company: "Gamma",
    temperature: "cold",
    pipeline_stage: "negotiation",
    next_follow_up_at: new Date(Date.now() - 3600000).toISOString(),
    last_interaction_at: new Date(Date.now() - 259200000).toISOString(),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    archived: false,
  } as Lead,
];

export const mockDeals: Deal[] = [
  {
    id: "deal-1",
    workspace_id: ws,
    lead_id: "lead-1",
    title: "Acme — Enterprise",
    value: 4800,
    currency: "EUR",
    probability: 60,
    stage: "qualified",
    order_status: "none",
    expected_close_date: new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10),
    delivery_date: null,
    created_at: new Date().toISOString(),
    updated_at: new Date(Date.now() - 86400000).toISOString(),
  } as Deal,
  {
    id: "deal-2",
    workspace_id: ws,
    lead_id: "lead-2",
    title: "Beta — Subscription",
    value: 2340,
    currency: "EUR",
    probability: 40,
    stage: "proposal_sent",
    order_status: "none",
    expected_close_date: new Date(Date.now() + 7 * 86400000).toISOString().slice(0, 10),
    delivery_date: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  } as Deal,
  {
    id: "deal-3",
    workspace_id: ws,
    lead_id: "lead-3",
    title: "Gamma — Renewal",
    value: 1100,
    currency: "EUR",
    probability: 25,
    stage: "negotiation",
    order_status: "none",
    expected_close_date: new Date(Date.now() + 21 * 86400000).toISOString().slice(0, 10),
    delivery_date: null,
    created_at: new Date().toISOString(),
    updated_at: new Date(Date.now() - 172800000).toISOString(),
  } as Deal,
  {
    id: "deal-won",
    workspace_id: ws,
    lead_id: "lead-1",
    title: "Won deal sample",
    value: 5000,
    currency: "EUR",
    probability: 100,
    stage: "won",
    order_status: "none",
    expected_close_date: null,
    delivery_date: null,
    closed_at: new Date().toISOString(),
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  } as Deal,
  {
    id: "deal-lost",
    workspace_id: ws,
    lead_id: "lead-2",
    title: "Lost deal sample",
    value: 1200,
    currency: "EUR",
    probability: 0,
    stage: "lost",
    order_status: "none",
    expected_close_date: null,
    delivery_date: null,
    closed_at: new Date().toISOString(),
    loss_reason: "competitor",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  } as Deal,
];
